"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm-4.948-8.683L8 13c.949-.316.948-.317.948-.317v-.004l.003.01.025.065a4.398 4.398 0 00.667 1.106C10.14 14.456 10.881 15 12 15c1.119 0 1.86-.544 2.357-1.14a4.396 4.396 0 00.692-1.17l.004-.011v.002l-.001.001s0 .002.948.318c.949.316.948.317.948.317v.003l-.002.005-.005.014a5.027 5.027 0 01-.063.165 6.395 6.395 0 01-.985 1.636C15.14 16.044 13.881 17 12 17c-1.881 0-3.14-.956-3.893-1.86a6.397 6.397 0 01-.985-1.636 4.118 4.118 0 01-.063-.165l-.005-.014-.001-.005-.001-.003zM8 8h2v3H8V8zm8 0h-2v3h2V8z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;